import { ComponentProps, FC, JSX, JSXElementConstructor } from 'react';
import classNames from 'classnames';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function asMenuItem<P extends JSXElementConstructor<any>>(Wrap: P): FC<ComponentProps<P>>;
// eslint-disable-next-line no-redeclare
export function asMenuItem<P extends keyof JSX.IntrinsicElements>(Wrap: P): FC<ComponentProps<P>>;
// eslint-disable-next-line no-redeclare, @typescript-eslint/no-explicit-any
export function asMenuItem<P extends JSXElementConstructor<any>>(Wrap: P | keyof JSX.IntrinsicElements) {
  return ({ className, ...props }: typeof Wrap extends P ? ComponentProps<P> : ComponentProps<typeof Wrap>) => {
    return <Wrap
      {...props as ComponentProps<typeof Wrap>}
      className={classNames(
        'flex gap-3 pl-10 pr-4 py-6 align-center items-center text-body-1-xl text-secondary-500 relative rounded-r-2xl',
        'transition-all',
        'before:content-[""] before:absolute before:inset-y-1/2 before:inset-x-1/2 before:rounded-r-2xl before:-z-10 before:transition-all',
        'hover:before:bg-secondary-transparent-5 hover:before:m-2 hover:before:rounded-[99px] hover:before:inset-x-0 hover:before:inset-y-0',
        '[&.active]:text-base-front-active [&.active]:bg-secondary-transparent-5 [&.active]:before:inset-x-0 [&.active]:before:inset-y-0',
        className
      )}
    />;
  };
}
